module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('App', {
		__constructor: function () {
			this.callParent('__constructor', arguments);
			this.ready = false;
			this.environment = {};
		},

		configure: function(options) {
			if (typeof startTime !== 'undefined') {
				this._loadTime = new Date().getTime() - startTime;
			} else {
				this._loadTime = false;
			}

			this.registerOptions('', {
				widgets: {
					logoutApi: {
						widget: 'Api',
						method: 'site.authorizer.logout'
					},
					navi: {
						womPriority: 2,
						widget: 'Navigator',
						'$navigation': '@root:navigation'
					},
					socket: {
						womPriority: 1,
						widget: 'Socket'
					},
					router: {
						womPriority: 1,
						widget: 'Router',
						'$map': '@root:map',
						'navigator': '@root #navi'
					}
				},
				handleWom: {
					logout: {
						widget: '#logoutApi',
						event: 'ready',
						callback: function() {
							window.location.reload();
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		handleFoxReady: function(waitTime) {
			if (!this._readyHandler) {
				this._readyHandler = {};
				this.handleEvent('~.Api', 'startWorking', function(data, api) {
					if (!this._readyHandler.collecting) {
						return;
					}

					if (!this._readyHandler.stopWaitingTimeout) {
						this._readyHandler.stopWaitingTimeout = setTimeout(fox.bind(function () {
							this._readyHandler.collecting = false;
						}, this), 1000);
					}
					if (!this._readyHandler.waitApi[api.getId()]) {
						this._readyHandler.waitApi[api.getId()] = true;
						this._readyHandler.count++;
					}
				}, {prefix: 'foxReady'});
				this.handleEvent('~.Api', 'stopWorking', function(data, api) {
					if (!this._readyHandler.working) {
						return;
					}

					if (this._readyHandler.waitApi[api.getId()]) {
						this._readyHandler.waitApi[api.getId()] = false;
						this._readyHandler.count--;
						if (!this._readyHandler.count) {
							this._readyHandler.working = false;
							setTimeout(function() {
								fox.ready = true;
								this.ready = true;
								this.dispatchEvent('fox_ready');
								window.postMessage("fox_ready", "*");
							}.bind(this), 500);
						}
					}
				}, {prefix: 'foxReady'});
			}
			if (this._readyHandler.working) {
				return;
			}
			this._readyHandler.waitApi = {};
			this._readyHandler.count = 0;
			this._readyHandler.collecting = true;
			this._readyHandler.working = true;
			this._readyHandler.stopWaitingTimeout = null;
			this._readyHandler.maxTime = setTimeout(fox.bind(function () {
				if (this._readyHandler.working && !this._readyHandler.count) {
					this._readyHandler.collecting = false;
					this._readyHandler.working = false;
					fox.ready = true;
					this.ready = true;
					window.postMessage("fox_ready", "*");
					this.dispatchEvent('fox_ready');
				}
			}, this), waitTime || 500);
		},

		init: function() {
			this.registerOptions('~.Widget', {
				'templateEnv.env': this.environment
			});
			
			this.callParent('init', arguments);
			this.customInit();
		},

		initWithChildren: function() {
			this.handleFoxReady(3000);
			this.callParent('initWithChildren', arguments);
			this.embedWidgets(this.getOption('map.widgets'), true);

			this.rwom1('#navi').start();
		},
		 
		setElement: function(node) {
			this.element = node;
		},

		running: function() {
			if (!this.element) {
				this.element = document;
			}

			this.afterEmbed();

			var ga = this.wom1('#googleAnalytics');

			if (this._loadTime && ga) {
				ga.trackTiming(['load', 'app', this._loadTime, 'app', 100]);
			}
		},

		//TODO remove 
		
		gotoPage: function(alias, params) {
			var skipEvent;

			if (fox.isUndefined(alias)) {
				alias = 'home';
			}

			if (params) {
				params[0] = alias;
			} else {
				params = {0: alias};
			}

			if (fox.isSet(params.skipEvent)) {
				skipEvent = params.skipEvent;
				delete params.skipEvent;
			} else {
				skipEvent = null;
			}

			this.rwom1('#navi').update(params, skipEvent);

			if (skipEvent) {
				this._gotoPage(alias);
			}
		},
		
		runPage: function(alias, params) {
			this.gotoPage(alias, params);
		},

		_gotoPage: function(alias) {
			this.rwom1('#router').navigate(alias);
		},

		customInit: function() {
			if (document.location.href.indexOf('splash=1') !== -1) {
				fox.cookie.set('splash', 1);
			}

			this._customData = {};

			this.dl = this._wom.loadWidget('Datalayer').set(this.getOption('site'));
			
			this.page = {};
			this.layout = {};

			this.registerOptions('.Site_Layout', {'embed.container': this.getOption('container') || 'body .wrapper'});
			
			this.setEnv('cookie', fox.cookie.getAll());
			
			if (this.options.design && !this.getEnv('design')) {
				this.setEnv('design', this.options.design);
			}
			
			if (this.options['billing'] && !this.getEnv('billing')) {
				this.setEnv('billing', this.options.billing);
			}
			
			if (this.options['public'] && !this.getEnv('public')) {
				this.setEnv('public', this.options['public'] || {});
			}

			if (this.options.member) {
				this.member = fox.hydrateDl(this.options.member);
				this.setOption('$map', '@this:mapMember');

				this.registerOptions('~.Widget', {
					'templateEnv.member': this.member
				});
			} else {
				this.member = false;
				this.setOption('$map', '@this:mapGuest');
			}

			if (this.options.client) {
				this.client = this.options.client;
			} else {
				this.client = false;
			}

			this.registerOptions('~.Api', {'domain': this.getOption('siteDomain')});
		},

		setCustomData: function(name, data) {
			this._customData[name] = data;
			return this;
		},

		getCustomData: function(name) {
			return this._customData[name]; 	
		},

		cleanCustomData: function(name) {
			delete this._customData[name];
			return this;
		},

		login: function(member, hash, redirectHash) {
			if (member.collection) {
				this.member = fox.hydrateDl(member);
			} else if (member) {
				this.member = fox.createDl().addObject(member);
			} else {
				this.member = false;
			}

			this.dispatchEvent('logged', member);
		},

		logout: function() {
			this.member = false;
			this.rwom1('#logoutApi').send();
		},

		setEnv: function() {
			var args = fox.clone(arguments);

			if (args.length === 1) {
				fox.each(args[0], function (value, path) {
					if (fox.isNumeric(path) && value.path && value.value) {
						return this.setEnv(value.path, value.value);
					}

					return this.setEnv(path, value);
				}, this);
			} else if (args.length === 2) {
				fox.objectSet(this.environment, args[0], args[1]);
			}
			
			return fox;
		},

		getEnv: function(path) {
			return fox.objectGet(this.environment, path);
		},
	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/site/app.js
// module id = 221
// module chunks = 0